@import '~style-sheet-helpers/core.less';

.header-container {
  display: flex;
  align-items: center;
  width: 75%;
}

.header-container b {
  max-width: 300px;
  .truncate();
  &.order-number-part {
    min-width: 200px;
  }
}

.third-party-logo {
  height: 20px;
  width: 20px;
  min-width: 20px;
  align-self: center;
  margin-right: 5px;
}
.loading-indicator-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  line-height: 1.5;
  .loading-indicator {
    height: 20px;
    width: 20px;
  }
}
